import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=0ab5930d&scoped=true&"
import script from "./Usage.vue?vue&type=script&lang=ts&"
export * from "./Usage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5930d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab5930d')) {
      api.createRecord('0ab5930d', component.options)
    } else {
      api.reload('0ab5930d', component.options)
    }
    module.hot.accept("./Usage.vue?vue&type=template&id=0ab5930d&scoped=true&", function () {
      api.rerender('0ab5930d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/analytics/Usage.vue"
export default component.exports